import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import styles from './closet_em_movimento__.module.scss';
import Perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const BTN_TEXT = '#EDE5D4';

/** Ajuste para os links reais da marca */
const INSTAGRAM_URL = 'https://www.instagram.com/closet.em.movimento__?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const WHATSAPP_NUMBER = '5517992347943';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const MAPS_URL = 'https://maps.app.goo.gl/xjZ99ufn771pKtvC7';

const Closet_em_movimento__: React.FC = () => {
    return (
        <div className={styles.closet_em_movimento__}>
            <div className={styles['body-thunder']}>
                <div className={styles['container-thunder']}>
                    <div className={styles.profileStack}>
                        <img
                            className={styles.profileImage}
                            src={Perfil}
                            alt="Closet em Movimento"
                            width={280}
                            height={280}
                            decoding="async"
                        />
                        <div className={styles.links}>
                            <a
                                href={INSTAGRAM_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <InstagramIcon height="24" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>INSTAGRAM</span>
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <WhatsappIcon height="28" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>WHATSAPP</span>
                            </a>
                            <a
                                href={MAPS_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FaMapMarkerAlt size="22" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>LOCALIZAÇÃO</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Closet_em_movimento__;
